<template>
  <div class="md:hidden">

    <p class="font-medium text-sm text-gray-700"></p>
  </div>

  <div class="min-h-screen w-[90%] mx-auto md:w-full pb-16 md:pb-0">
    <!-- Back -->
    <div class="flex items-center mb-6 md:mb-8">
      <!-- <svg
        @click="goBack"
        class="w-6 h-6 text-[#0C5542] cursor-pointer mr-3 hidden sm:block"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 19l-7-7 7-7"
        />
      </svg> -->

      <!-- Title -->
      <h2 class="text-[22px] md:text-[26px] font-bold text-gray-900 hidden sm:block">
        Privacy Policy
      </h2>
    </div>

    <!-- Card -->
    <div class="bg-white rounded-xl border border-gray-200
             p-5 md:p-7 mb-6 md:mb-9 shadow-sm
             w-full md:w-auto">
      <h3 class="text-[15px] md:text-[16px] font-semibold text-gray-900 mb-3 md:mb-4">
        Summary of our privacy policy:
      </h3>

      <div class="flex flex-col gap-3 md:gap-4">
        <div v-for="(section, index) in privacySections" :key="index" class="pb-1">
          <h4 class="font-bold text-[14px] md:text-[15px] text-gray-900 mb-1">
            {{ section.title }}
          </h4>
          <p class="text-sm text-gray-600 leading-relaxed whitespace-pre-line">
            {{ section.content }}
          </p>
        </div>
      </div>
    </div>

    <!-- Agreement -->
    <div class="mb-6 md:mb-8">
      <h3 class="text-sm md:text-lg font-medium text-[#111111] mb-3 md:mb-4">
        I hereby agree that:
      </h3>

      <ol class="ml-5 mb-3 md:mb-4 list-decimal text-sm md:text-base text-[#626363] leading-relaxed">
        <li>
          Consent for Access and Processing of Data for Hamara Mall Transactions:
        </li>
      </ol>

      <div class="bg-[#D1E7DD] rounded-lg p-4 md:p-5 space-y-2 md:space-y-3">
        <p class="text-sm md:text-base text-[#828282] leading-relaxed">
          <span class="text-[#828282] font-normal">[a]</span> By proceeding, I provide my consent to
          <span class="font-semibold">Hamara Mall</span> to enable access to and facilitate my transactions on
          <span class="font-semibold">the platform</span>, including browsing products, placing orders, availing offers,
          and completing purchases through integrated partners and services.
        </p>

        <p class="text-sm md:text-base text-[#828282] leading-relaxed">
          <span class="text-[#828282] font-normal">[b]</span> I further agree to the collection and processing of my
          information for the purpose of
          <span class="font-semibold">order fulfillment, payment processing, customer support, and improving my shopping
            experience</span>,
          in accordance with applicable terms and privacy policies.
        </p>
      </div>
    </div>
  </div>

  <!-- Button -->
  <div v-if="isMobile" class="w-full fixed bottom-0 h-[72px] bg-white rounded-t-lg px-4 py-4">
    <div class="w-full max-w-[375px] mx-auto">
      <button @click="navToBack" class="w-full h-[40px] bg-primary text-white font-semibold
               rounded-lg py-2.5">
        GOT IT
      </button>
    </div>
  </div>
</template>




<script setup lang="ts">
import { ref } from 'vue'
const { isMobile } = useDevice();
const navToBack = () => {
  window.history.back();
}

const privacySections = ref([
  {
    title: "Privacy Policy",
    content: `
Last updated on 3rd Jan 2022

YOU ARE ADVISED TO REVIEW THIS PRIVACY POLICY CAREFULLY SO THAT THE YOU UNDERSTAND OUR PRIVACY PRACTICES. BY USING OUR WEBSITE (DEFINED BELOW), YOU WILL BE DEEMED TO HAVE READ, UNDERSTOOD AND AGREED TO THE PRACTICES AND POLICIES OUTLINED IN THIS PRIVACY POLICY AND AGREE TO BE BOUND BY THE PRIVACY POLICY. YOU HEREBY CONSENT TO OUR COLLECTION, USE, STORING AND SHARING OF YOUR PERSONAL INFORMATION AS DESCRIBED IN THIS PRIVACY POLICY. IF YOU USE THE SERVICES ON BEHALF OF SOMEONE ELSE, YOU REPRESENT THAT YOU ARE AUTHORISED BY SUCH INDIVIDUAL OR ARE LEGALLY AUTHORIZED TO (I) ACCEPT THIS PRIVACY POLICY ON SUCH INDIVIDUAL’S BEHALF, AND (II) CONSENT ON BEHALF OF SUCH INDIVIDUAL TO OUR COLLECTION, USE AND DISCLOSURE OF SUCH INDIVIDUAL’S PERSONAL INFORMATION AS DESCRIBED IN THIS PRIVACY POLICY.

YOU FURTHER UNDERSTAND THAT THIS WEBSITE MAY CONTAIN LINKS TO OTHER SITES THAT WE DO NOT OPERATE. IF YOU CLICK ON A THIRD-PARTY LINK, YOU WILL BE DIRECTED TO THAT THIRD PARTY’S SITE. WE ADVISE YOU TO REVIEW THE PRIVACY POLICY OF EVERY SITE YOU VISIT.

WE HAVE NO CONTROL OVER AND ASSUME NO RESPONSIBILITY FOR THE CONTENT, PRIVACY POLICIES OR PRACTICES OF ANY THIRD-PARTY SITES OR SERVICES.
`
  },
  {
    title: "1. INTRODUCTION",
    content: `
nStore Technologies Private Limited (“NTPL” “us,” “we,” or “our”) is committed to provide You(“ You”, “ Your” and “ User” and “Consumer”) a secure shopping experience by managing Your personal information secure in accordance with the prevailing Indian laws. We respect the privacy of everyone who visits/uses the Website. The nature of services provided by us requires us to collect information including but not limited to Your name, age, gender, date of birth, medical records and financial records (“Personal Information”). This privacy policy (“Privacy Policy”) describes the procedures for collecting, using, storing and managing Your Personal Information, which You share with us for availing the services or accessing the Website. We recommend You read this Privacy Policy so that You understand the type of Personal Information collected by us and the way we manage Your Personal Information.

We operate this website/ link/ application (“Website”), to provide You a platform (“Platform”) to find and shop the Products listed by the stores near You (“Service”) and pay for it online. Any person visiting this Website or using the Services shall be presumed to have read these Privacy Policy and unconditionally and irrevocably accepted the terms and conditions set out herein.
`
  },
  {
    title: "2. DEFINITIONS",
    content: `
2.1. “Merchant” shall mean the merchants or the retailer who lists their Products on the Platform for sale.

2.2. “Product” shall mean a tangible/intangible product or service listed on the Platform by the Merchants for sale.

2.3. “Payment Mechanism” shall mean the methods of facilitating the transfer of payment from Customers.
`
  },
  {
    title: "3. TYPE OF INFORMATION",
    content: `
3.1. We do not access Your personal information without Your consent. In order to avail our Services, you must register on our website. We collect and store information provided by You during Your registration with us to provide a better experience every time You visit our website. Following are the categories of information collected by us:

A. Transaction Information: This is an information about the transaction that You make through the Payment Mechanism as provided by us when we serve as a payment processing platform for Merchants.

B. Contact Information: We store Your contact information as provided by You while registering on our website to reach out to discuss and address any concerns that You may have about our Services. In order to serve You better, we also share Your contact information with the Merchants. You may contact respective Merchant to understand how the Merchant manages the contact information provided by You.

C. Billing information: We collect Your billing information as provided by You during the purchase of Products on the Website while using our Services.

D. Cookies: Cookies are files with a small amount of data, including a unique anonymous identifier. Cookies are sent to Your browser from a website and stored on Your computer’s hard drive. We use “Cookies” to collect information. We may use both Session Cookies (which expire once You close Your browser) and Persistent Cookies (which stay on Your computer until You delete them). You can instruct Your browser to refuse all cookies or to indicate when a cookie is being sent. However, if You do not accept cookies, You may not be able to use some portions of our Website or Services on this Website. For more information, please see our Cookie Policy.

E. Browsing information: We record information relating to Your use of NTPL Services and Website, such as the searches You undertake, the pages You view, Your browser type, IP address, location, requested URL, referring URL, and timestamp information.

F. Third-Party Services: We may use third-party services such as Google Analytics that collect, monitor, and analyze information to increase our Services’ functionality. These third-party service providers have their own privacy policies addressing how they use such information.`
  },
  {
    title: "4. OTHER INFORMATION",
    content: `
We also receive additional information about Your past payment pattern, information about Your device and geolocation such as IP address, device fingerprint from Your device. This information is strictly used for risk assessment and fraud prevention purposes.HOW WE USE PERSONAL INFORMATION

The Personal Information is collected and used to:
A. Operate NTPL electronic payments processing product and enable Your payment transactions and related purposes, such as authentication, dispute resolution, fraud prevention, and security.

B. Provide You with the products, services, programs, offers, or information as offered by the Merchants.

C. Understand how You and others use our Services for analytics and modeling and to create business intelligence and insights, and to understand economic trends.

D. Support our everyday business purposes, such as account management, quality control, website administration, business continuity and disaster recovery, security and fraud prevention, corporate governance, reporting, and legal compliance. Please note that we may also use and disclose information that is not personally identifiable. These reports do not contain any personal information.

E. Aggregate information to perform statistical analyses of User behavior and characteristics to measure interest in our Services.

F. We may share with any third-party certain information, that we have collected to better understand which services and advertisements may interest You.
`
  },
  {
    title: "5. DISCLOSURES",
    content: `
5.1.Affiliates. We may provide Personal Information to our affiliates. For example, we may disclose Personal Information to our affiliates to respond to Your requests for information or Services, or to help limit Your receipt of marketing materials You have requested not to receive.

5.2. Service Providers or Business Partners. We may use certain third-party companies and individuals to help us provide, analyze, and improve the Services (including but not limited to data storage, maintenance services, database management, web analytics, payment processing, hosting services, business functions and improvement of the Service’s features. The third parties may have access to Your information only for purposes of performing these tasks on our behalf and shall be incompliance with the terms of this Privacy Policy.

5.3. Third-Party Applications: We may share Your information to third-parties with Your consent, for example when You choose to access our Services through such an application. We have no control over how the information is processed by the third-party application. We shall not be responsible for any breach on account of such party, and You consent to the use of your information

5.4. Joint Marketing Arrangements. Where permitted by law, we may provide Personal Information to joint marketers with whom we have a marketing arrangement, if any. We shall require all joint marketers to have written contracts with us that specify appropriate use of Your Personal Information, require them to safeguard Your Personal Information, and prohibit them from making unauthorized or unlawful use of Your Personal Information.

5.5. Analysis: Information given by You may be bulked together with information of all Merchants and then the compressed and analyzed data may be used for making presentations, consolidation reports, analysis etc. However, in all such cases, your identity will be protected and no personal information of any sort shall be parted to any third party. Your contact information is stored in our database and is only used to contact You during Your association with us.

5.6. Persons Who Acquire Our Assets or Business. If we sell or transfer any of our business or assets, certain Personal Information may be a part of that sale or transfer. In the event of such a sale or transfer, we shall notify You.

5.7. Legal and Regulatory Authorities. We may be required to disclose Your Personal Information due to legal or regulatory requirements. In such instances, we reserve the right to disclose Your Personal Information as required to comply with our legal obligations, including but not limited to complying with court orders, warrants, or discovery requests. You agree and acknowledge that we may not inform You prior to or after disclosures made according to this section.`
  },
  {
    title: "6. DATA RETENTION",
    content: `
We may retain and use Your Personal Information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements. Consistent with these requirements, we shall try to delete Your Personal Information quickly upon reasonable request. Please note, however, that there might be latency in deleting Personal Information from our servers and backed-up versions might exist after deletion. In addition, we do not delete from our servers’ files that you have in common with other users.`
  },
  {
    title: "7. THIRD PARTY LINKS",
    content: `
7.1. NTPL Websites may include third-party advertising and links to other websites and apps. Third-party advertising partners may collect information about You when You interact with their content, advertising, and services. Such content is subject to their terms of use and any additional guidelines and privacy information provided in relation to that use on their website.

7.2. We recommend that You check the policy of each website You visit to better understand Your rights and obligations especially when You are submitting any type of content on those third-party websites. Please contact the owner or operator of such website if You have any concerns or questions.`
  },
  {
    title: "8. INDEMNIFICATION",
    content: `
8.1. The User agrees and undertakes to indemnify and hold harmless NTPL from and against any and all suit, dispute, actions, damages, costs and expenses, if any, of whatsoever nature, arising out of or in any way connected with this Privacy Policy, information and/or the User’s use or access to this Website.

8.2. The User expressly understands that under no circumstances, including, but not limited to, negligence, shall we be liable to the User for any direct, indirect, incidental, special, or consequential damages, including, but not limited to damages for loss of profits, goodwill, use, data or other intangible losses, resulting from circumstances, including but not limited to:

A. unauthorized access to or alteration of Personal Information.

B. any unauthorized access to or use of our secure servers and/or any or all information stored therein.

C. The User represents that the User has accessed the Website and has provided information on the User’s own initiative and is responsible for compliance with all applicable laws including, but not limited to, any applicable local laws.`
  },
  {
    title: "9. LIMITATION OF LIABILITY",
    content: `
NTPL shall not be liable for any damages, direct or indirect, incidental or consequential, and all liabilities (including for negligence, loss or damage such as loss of revenue, unavailability of system or loss of data and loss of Your Personal Information) and for use of or inability to use Services of any kind that is offered or to provide indemnity or any other remedy to You or any third party.
`
  },
  {
    title: "10. SECURITY",
    content: `
We value your Personal Information, and we shall ensure an adequate level of protection. We have therefore implemented technology and policies with the objective of protecting your Personal Information from unauthorized access and improper use and shall update these measures as new technology becomes available, as appropriate. As a matter of security, we take back-up of systems periodically. Although we provide appropriate firewalls and protections, our systems are not hack proof. Data pilferage due to unauthorized hacking, virus attacks, technical issues is possible, and we take no liabilities or responsibilities for it.`
  },
  {
    title: "11. ACCESS",
    content: `
You can access your information, including your name, address, payment options, profile information and other details in the “Your Account” section of the website

Further, the business of making payment contemplated hereinis aimed at persons who can execute agreements legally. We therefore ask You, if You are not eligible to execute any agreement, not to send Your Personal Information (for example, Your name, mobile number and email address).`
  },
  {
    title: "12. CHILDREN’S DATA",
    content: `
NTPL’s platforms are not directed to children, and NTPL does not knowingly collect, track, process, disseminate and store personal information from children under the age of 18. We only collect data from persons over the age of 18 years and who are allowed by law to interact with NTPL. If You believe that we are processing a child’s personal information inappropriately, please contact us at support@nstore.in.`
  },
  {
    title: "13. CHANGES TO THIS PRIVACY POLICY",
    content: `
13.1. We may update this Privacy Notice from time to time. If the changes materially affect the way we use identifiable information that we have already collected, we shall notify our Users on our Website.

13.2. The continued usage of our Services and this Website after such changes have been made to these terms will mean that the User accepts these changes. Therefore, the User is requested to kindly check the privacy policy regularly for updates.`
  },
  {
    title: "14. GOVERNING LAW",
    content: `
This Privacy Policy is governed by the laws of India for users in India and the appropriate courts at Chennai, India shall have exclusive jurisdiction.
`
  },
  {
    title: "15. FEEDBACK",
    content: `
15.1. We are interested in Your views, and we value feedback, we therefore may set up blogs and chat rooms for providing better Services and to receive Your feedbacks. We encourage You to be careful about what Personal Information You disclose in this way.

15.2. Subject to any applicable law, any communication sent by You via NTPL or through the blogs chat rooms or otherwise to us (including without limitation contents, images, audio, feedback etc. collectively “Feedback”) is on a non-confidential basis, and we are under no obligation to refrain from reproducing, publishing or otherwise using it in any way or for any purpose. We can use the Feedback, including without limitation to any ideas, inventions, concepts, techniques or know-how disclosed therein, for any purpose including without limitation to developing, manufacturing and/or marketing Services. You agree you shall not assert any ownership right of any kind in the Feedback (including without limitation copyright, patent, Trademark, unfair competition, moral rights, or implied contract) and You hereby irrevocably waive the right to receive any financial or other consideration in connection with the Feedback, including without limitation acknowledgment of You as the source of the Feedback. Your submission of any Feedback shall constitute an assignment to us of all worldwide rights, titles and interests in all copyrights and other intellectual property rights in the Feedback.

15.3. If You register or respond to advertisements or posts on NTPL or post any content on Website, we may send You certain notifications, advertisements, promotions, surveys and specials. We may also send You any legally required notifications and certain notifications, including but not limited to, Service-related notices or notices regarding a change to any of our policies. For example, we may send You a notice regarding server problems or scheduled maintenance to nStore. In order to opt-out of receiving these notices, you may need to deactivate Your account. We shall not change Your preferences without Your consent.
`
  },
  {
    title: "16. CONTACT US",
    content: `
If You have questions or concerns or grievances regarding this Privacy Policy, You can e-mail us at support@nstore.in`
  }
])


const goBack = () => {
  console.log('Go back')
}

</script>